import * as types from '../constants/ActionTypes';
let withClient = false;
try {
  withClient = localStorage.getItem('withClient')
} catch (e) {
  console.warn(e.message);
}

const initialState = {
  withClient: withClient === 'true' ? true : withClient === 'false' ? false : null,
}

export default function profile(state = initialState, action) {
  switch (action.type) {
    case types.SWITCH_WITH_CLIENT:
      localStorage.setItem('withClient', !state.withClient)
      return {
        ...state,
        withClient: !state.withClient,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/privacy.js